<template>
  <module-list-layout :createAction="createAction" :module="module" class="p-2" v-if="amReady">

    <el-dialog top="5vh" :visible.sync="uploadVendorRateDialogVisibility" title="" width="97%" :append-to-body="true" style="z-index: 2">
      <uploadDocumentRate :editMode="false" :afterUploadCallback="afterUploadCallback" v-if="uploadVendorRateDialogVisibility" :targetVendorId="targetVendorId"></uploadDocumentRate>
    </el-dialog>

    <el-dialog top="5vh" :visible.sync="vendorRatesDialogVisible" title="" width="97%">
      <showVendorRates v-if="vendorRatesDialogVisible" :targetVendorId="targetVendorId"></showVendorRates>
    </el-dialog>

    <el-dialog
        :visible.sync="deleteConfirmDialogVisible"
        title="Confirm Delete" width="300">
      <div slot="title" style="font-size: 21px">
        Confirm Delete
      </div>
      <!--<div class="w-100 el-icon-warning-outline" style="font-size: 42px;" align="center">
      </div>-->
      <p class="ml-3 text-danger">
        Are you sure you want to delete this vendor ? <br>
        all details related will be removed as will such as rates and  calls history
      </p>

      <span class="dialog-footer" slot="footer">
        <el-button @click="deleteConfirmDialogVisible = false">Cancel</el-button>
        <el-button @click="removeAction" type="danger">Delete</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible" title="" top="5vh" width="75%">
      <moduleForm
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="editMode"
          :formHeader="true"
          :on-create-callback="afterCreate"
          :on-edit-callback="afterEdit"
          :profilesList="profilesList"
          v-if="dialogVisible"></moduleForm>
    </el-dialog>

    <div class="p-3">
      <div class="row">
        <div class="col-12 col-md-6 pt-2">
          <span class="ag-grid-quick-search-label">Search</span>
          <span><el-input class="d-inline-block w-50" size='mini' v-model="userSearch"></el-input></span>
        </div>
        <div class="col-12 col-md-6">
          <pagination
              :currentPage="currentPage"
              :margin-pages="2"
              :navigateHandler="navigateToPage"
              :page-count="getPagesCount()"
              :page-range="4"
              paginateClass=""></pagination>
        </div>
      </div>
    </div>

    <app-ag-grid :agGrid="agGrid"></app-ag-grid>
  </module-list-layout>
</template>

<script>
import Vue from 'vue'
import {AgGridVue} from 'ag-grid-vue';
import actionsCell from './ag-grid/ActionsCell'
import statusViewer from './ag-grid/StatusViewer'
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'
import {mapActions} from "vuex";
import vendorRatesCounterViewer from '@/modules/voip-vendor/list/page/ag-grid/VendorRatesCounterViewer'

export default {
  watch: {
    userSearch: function (val) {
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityList({page: 1, search: this.userSearch}).then(response => {
          this.agGrid.rowData = response.rows;
          this.recordsCounter = response.count;
          this.amReady = true
        })
        this.currentPage = 1;
        //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    }
  },
  components: {
    uploadDocumentRate: () => import('@/modules/voip-vendor/upload-document-rate/View.vue'),
    pagination: () => import('@/components/pagination/View.vue'),
    moduleForm: () => import('../../form/View'),
    moduleListLayout: () => import('@/modules-config/layouts/list/View.vue'),
    showVendorRates: () => import('@/modules/voip-vendor/view-rates/View')
  },
  data() {
    return {
      userSearchTimeOut: null,
      amReady: false,
      module: {
        ...module
      },
      uploadVendorRateDialogVisibility: false,
      vendorToDeleteId: null,
      targetVendorId: null,
      deleteConfirmDialogVisible: false,
      vendorRatesDialogVisible: false,
      showPasswordField: false,
      selectedUsername: ' - ',
      selectedUserId: null,
      setProfitRateDialogVisible: false,
      viewUserTestsDialogVisible: false,
      setWorkingRatesDialogVisible: false,
      userSearch: null,
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: true,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            params.api.sizeColumnsToFit()
          }
        },
        columnDefs: [
          {
            field: 'name',
            headerName: this.$ml.get('name'),
            headerClass: this.$langConfig.lang + '-lang-text',
            autoHeight: true
          },
          {
            field: 'division_name',
            headerName: 'Division',
            headerClass: this.$langConfig.lang + '-lang-text',
            autoHeight: true
          },
          {
            field: 'prefix',
            headerName: 'Prefix',
            headerClass: this.$langConfig.lang + '-lang-text',
            autoHeight: true
          },
          {
            field: 'current_rates_counter',
            headerName: this.$ml.get('rates_counter'),
            headerClass: this.$langConfig.lang + '-lang-text',
            autoHeight: true,
            cellRendererFramework: Vue.extend(vendorRatesCounterViewer)
          },
          {
            field: 'created_at',
            headerName: 'Created',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            width: 80,
            headerName: this.$ml.get('actions'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: Vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }
        ],
        rowData: []
      }
    };
  },
  beforeMount() {
    this.navigateToPage(1)
  },
  beforeDestroy() {
  },
  methods: {
    afterUploadCallback () {
      this.uploadVendorRateDialogVisibility = false
      this.agGrid.rowData[this.rowToEdit].current_rates_counter = -1
      this.refreshGrid();
    },
    uploadVendorRate(params) {
      this.uploadVendorRateDialogVisibility = true
      this.targetVendorId = params.data.id
      this.rowToEdit = params.rowIndex
    },
    removeActionConfirm(params) {
      this.deleteConfirmDialogVisible = true
      this.vendorToDeleteId = params.data.id
      this.rowToEdit = params.rowIndex;
    },
    showVendorRates (params) {
      this.targetVendorId = params.data.id
      this.vendorRatesDialogVisible = true
    },
    downloadRateFile (params) {
      let url = process.env.VUE_APP_VOIP_GENERAL_BACKEND_SERVICE_URL + '/storage/' + params.data.file_name
      window.open(url, '_blank');
    },
    ...mapActions('voip-vendor-api', {getEntityList: 'list'}),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      this.getEntityList({page: page, userSearch: this.userSearch}).then(response => {
        this.agGrid.rowData = response.rows;
        this.recordsCounter = response.count;
        this.amReady = true
      })
      this.currentPage = page;
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})
      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreateProfitPercent() {
      this.setProfitRateDialogVisible = false
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.showPasswordField = true;
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    editAction(params) {
      this.showPasswordField = false;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
      this.dialogVisible = true;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    removeAction(params) {
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: this.vendorToDeleteId}).then(response => {
        this.agGrid.rowData.splice(this.rowToEdit, 1);
        this.refreshGrid();
        this.rowsCounter -= 1;
        this.deleteConfirmDialogVisible = false
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
